import { configureStore } from "@reduxjs/toolkit";
import CustomerList from "./Slices/CustomerSlice/CustomerList";
import branchList from "./Slices/Master/Branch/branchList";
import itemList from "./Slices/Items/ItemList";
import PendingOrder from "./Slices/Orders/PendingOrder";
import ApprovedOrder from "./Slices/Orders/ApprovedOrder";
import OrderList from "./Slices/Orders/OrderList";
import SchemList from "./Slices/Orders/SchemList";
import CityList from "./Slices/Orders/CityList";
import BussinessArea from "./Slices/LoginSlice/BussinessArea";
import PendingAmt from "./Slices/Orders/PendingAmt";
import OrderDetails from "./Slices/Orders/OrderDetails";
import ManufacturList from "./Slices/Orders/ManufacturList";
import DashboardSalesOrderList from "./Slices/DashboardSlice/DashboardSalesOrderList";
import ApprovalPending from "./Slices/DashboardSlice/ApprovalPending";
import SOTotal from "./Slices/DashboardSlice/SOTotal";
import PendingDispatch from "./Slices/DashboardSlice/PendingDispatch";
import ChallanList from "./Slices/Challan/ChallanList";
import LedgerList from "./Slices/Ledger/LedgerList";
import ProductList from "./Slices/Product/ProductList";
import CategoryList from "./Slices/Category/CategoryList";
import Pdf from "./Slices/Pdf/Pdf";
import InvoicePdf from "./Slices/Pdf/InvoicePdf";
import SalesPurchaseGraph from "./Slices/DashboardSlice/SalesPurchaseGraph";
import DashboardLastOrder from './Slices/DashboardSlice/DashboadLastOrder';
import DueAmtByDays from './Slices/DashboardSlice/DueAmtByDays'
import SalesReturnList from './Slices/sales-return-list/SalesReturnList'
import VoucherList from './Slices/discount-voucher-list/VoucherList'
import DebitCreditNote from './Slices/debit-credit-note/DebitCreditList'
import SalesMonthYearWise from './Slices/DashboardSlice/SalesYearMonthWise'
import FinYearList from './Slices/LoginSlice/FinYearList'
import QuaterlyTargetOne from './Slices/DashboardSlice/QuaterlyTargetOne'
import QuaterlyTargetTwo from './Slices/DashboardSlice/QuaterlyTargetTwo'
import QuaterlyTargetThree from './Slices/DashboardSlice/QuaterlyTargetThree'
import QuaterlyTargetFour from './Slices/DashboardSlice/QuaterlyTargetFour'
import DivisionList from './Slices/Orders/DivisionList'
import DistributorList from './Slices/Orders/DistributorList'

const Store = configureStore({
    reducer: {
        BussinessArea: BussinessArea,
        CustomerList: CustomerList,
        BranchList: branchList,
        ItemsList: itemList,
        PendingOrder: PendingOrder,
        ApprovedOrder: ApprovedOrder,
        OrderList: OrderList,
        SchemList: SchemList,
        CityList: CityList,
        PendingAmt: PendingAmt,
        OrderDetails: OrderDetails,
        ManufacturList: ManufacturList,
        DashboardSalesOrderList: DashboardSalesOrderList,
        SalesMonthYearWise: SalesMonthYearWise,
        QuaterlyTargetOne:QuaterlyTargetOne,
        QuaterlyTargetTwo:QuaterlyTargetTwo,
        QuaterlyTargetThree:QuaterlyTargetThree,
        QuaterlyTargetFour:QuaterlyTargetFour,
        FinYearList: FinYearList,
        ApprovalPending: ApprovalPending,
        SOTotal: SOTotal,
        PendingDispatch: PendingDispatch,
        // LedgerList: LedgerList,
        ChallanList: ChallanList,
        ProductList: ProductList,
        CategoryList: CategoryList,
        Pdf: Pdf,
        InvoicePdf: InvoicePdf,
        SalesPurchaseGraph : SalesPurchaseGraph,
        DueAmtByDays:DueAmtByDays,
        DashboardLastOrder:DashboardLastOrder,
        SalesReturnList: SalesReturnList,
        VoucherList :VoucherList,
        DebitCreditNote :DebitCreditNote,
        DivisionList:DivisionList,
        DistributorList : DistributorList
    }
})
export default Store;